import { useLocation, Navigate, Outlet } from "react-router-dom";
import UseAuth from "../../common/hooks/UseAuth";
import { Suspense } from "react";
import { Skeleton } from "antd";

const RequireAuth = ({ allowedRoles }) => {
  const { auth } = UseAuth();
  const location = useLocation();

  return allowedRoles?.includes(auth?.userType) ? (
    <Suspense fallback={<Skeleton />}>
      <Outlet />
    </Suspense>
  ) : auth?.userId ? (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireAuth;
